import React, { Component } from 'react'

// Check more icons at here https://react-icons.github.io/react-icons/icons?name=fa
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa'

import {
    PENDING_STATE,
    UNAVAILABLE_STATE,
    COMPLETED_STATE,
    DELETED_STATE,
    FAILED_STATE
} from '../../constants'

import {
    RESERVATION_SUCCESS,
    RESERVATION_FAILED,
    UPDATE_SUCCESS,
    UPDATE_FAILED,
    DELETE_SUCCESS
} from '../../strings'


class ReservationResult extends Component {

    render(){
        const {
            reservationState,
            reservationId,
            reservationProducts,
            parkingReservationState,
            errorMessages,
            isUpdate} = this.props
        var totalProducts = 0
        for (var product in reservationProducts){
            totalProducts += reservationProducts[product].value
        }
        return(
            <div className="reservation-result-block-container">
                {
                    ![PENDING_STATE, UNAVAILABLE_STATE].includes(reservationState) ?
                            <div className="reservation-result-block">
                                <div className="reservation-status-block">
                                    {
                                        reservationState === COMPLETED_STATE ?
                                        <p>{isUpdate ? UPDATE_SUCCESS : RESERVATION_SUCCESS}
                                            <FaCheckCircle className="icon-check-circle"/></p>:
                                            reservationState === FAILED_STATE ?
                                            <p>{isUpdate ? UPDATE_FAILED : RESERVATION_FAILED}
                                                <FaTimesCircle className="icon-fail-circle"/></p> : <div></div>
                                    }
                                    {
                                        reservationState === DELETED_STATE ?
                                        <p>{DELETE_SUCCESS} <FaCheckCircle className="icon-check-circle"/></p>:
                                        <div></div>
                                    }
                                </div>
                                {
                                    reservationState === COMPLETED_STATE ?
                                        <div className="reservation-number-block">
                                            <div>
                                                Código de reservación: {reservationId}
                                            </div>
                                        </div> :
                                        <div className="reservation-number-block-error">
                                            {errorMessages}
                                        </div>
                                }
                                {
                                    reservationState === COMPLETED_STATE && totalProducts > 0?
                                        <div className="reservation-number-block-warning">
                                            Debe cancelar: ₡{totalProducts} al SINPE móvil 6477-6099
                                        </div> : <div></div>
                                }
                                {
                                    reservationState === COMPLETED_STATE && parkingReservationState.length > 0 ?
                                    <div className="reservation-plate-warning">
                                        {parkingReservationState}
                                    </div> : <div></div>
                                }
                            </div>
                    : <div className="reservation-result-hidden">&nbsp;</div>
                }
            </div>
        )
    }
}

export default ReservationResult
